import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { api, type PortalPayload } from "./api";

// Shared portal data for every public page — fetched once per full page load,
// refreshed with `reload()` after mutations (e.g. a combined ballot submit).
const PortalContext = createContext<{
  data: PortalPayload | null;
  reload: () => Promise<void>;
}>({ data: null, reload: async () => {} });

export function PortalProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<PortalPayload | null>(null);

  const reload = async () => {
    try {
      setData(await api.portal());
    } catch {
      // keep the previous data; pages surface their own errors
    }
  };

  useEffect(() => {
    void reload();
  }, []);

  return <PortalContext.Provider value={{ data, reload }}>{children}</PortalContext.Provider>;
}

export function usePortal() {
  return useContext(PortalContext);
}
